import React from 'react';
import { Blog, Post } from '../blog/const';
import MetaTag from '@/components/ui/MetaTag';
import { Image, Link } from '@/components';
import { humanTimeArticle } from '@/libs/dayjs';
import { FacebookShareButton } from 'react-share';
import RelatedProduct from './partial/RelatedProduct';
import { useTranslation } from 'next-i18next';
import { ProductDiscountType } from '../products/shared';
import { ImageModel } from '@/models';
import { PagePath } from '@/layouts/shared';
import { Breadcrumb, BreadcrumbMobile } from './partial/Breadcrumb';
import AmbassadorRegistrationForm from './partial/ambassador-registration/AmbassadorRegistrationForm';

export type IRelatedProduct = {
  cat_code: string;
  id: number;
  images: ImageModel[];
  price: number;
  product_code: string;
  product_discount: ProductDiscountType;
  product_name: string;
  quantity: number;
  quotation: boolean;
  status: string;
  token: number;
};
export type IArticle = {
  article: Post;
  products: IRelatedProduct[];
  newArticles: Post[];
  blogs: Blog[];
};

export const EmagazineArticleLayout = (props: IArticle) => {
  const webUrl = process.env.APP_URL;
  const { t } = useTranslation(['layout']);
  const { products, article, newArticles, blogs } = props;
  const { yoast_head_json, title, categories, thumbnail_url, content } =
    article;
  return (
    <>
      <MetaTag
        title={title.rendered}
        description={yoast_head_json.description}
        seo={{
          title: title.rendered,
          description: yoast_head_json.description,
          keywords: article.acf?.keywords,
        }}
        image={thumbnail_url}
      />
      <h2 className="tw-hidden">{yoast_head_json.title}</h2>
      <h2 className="tw-hidden">{yoast_head_json.title}</h2>
      <div className="container tw-py-10 md:tw-border-t tw-border-primary-main tw-text-secondary-70">
        <Breadcrumb title={title.rendered} blogId={categories[0]} />
        <article className="tw-mt-10">
          <div
            className="tw-text-base md:tw-text-lg tw-mt-6 md:tw-mt-8 tw-text-gray-52 tw-w-full tw-prose tw-prose-sm md:tw-prose-base lg:tw-prose-lg content-article"
            dangerouslySetInnerHTML={{ __html: content.rendered }}
          ></div>
          <div className="tw-text-center tw-flex tw-items-center tw-justify-end tw-mt-5">
            Chia sẻ:&nbsp;
            <FacebookShareButton
              className=""
              url={`${webUrl}/article/${article.slug}`}
            >
              <Image
                src="/facebook-color.png"
                className="tw-w-8 tw-h-8"
                alt="facebook"
              />
            </FacebookShareButton>
          </div>
        </article>
        <AmbassadorRegistrationForm article={article} />
        {!!products.length && (
          <div className="tw-mt-10 tw-hidden lg:tw-block">
            <RelatedProduct products={products} t={t} />
          </div>
        )}
      </div>
    </>
  );
};
export const EmagazineArticleMobileLayout = (props: IArticle) => {
  const webUrl = process.env.APP_URL;
  const { t } = useTranslation(['layout']);
  const { products, article, newArticles, blogs } = props;
  const { yoast_head_json, title, categories, thumbnail_url, content } =
    article;
  return (
    <>
      <MetaTag title={title.rendered} image={thumbnail_url} />
      <h2 className="tw-hidden">{yoast_head_json.title}</h2>
      <h2 className="tw-hidden">{yoast_head_json.title}</h2>
      <div className="container tw-py-10 md:tw-border-t tw-border-primary-main tw-text-secondary-70">
        <BreadcrumbMobile title={title.rendered} blogId={categories[0]} />
        <article className="tw-mt-10">
          <div
            className="tw-text-base md:tw-text-lg tw-mt-6 md:tw-mt-8 tw-text-gray-52 tw-w-full tw-prose tw-prose-sm md:tw-prose-base lg:tw-prose-lg content-article"
            dangerouslySetInnerHTML={{ __html: content.rendered }}
          ></div>
          <div className="tw-text-center tw-flex tw-items-center tw-justify-end tw-mt-5">
            Chia sẻ:&nbsp;
            <FacebookShareButton
              className=""
              url={`${webUrl}/article/${article.slug}`}
            >
              <Image
                src="/facebook-color.png"
                className="tw-w-8 tw-h-8"
                alt="facebook"
              />
            </FacebookShareButton>
          </div>
        </article>
        <AmbassadorRegistrationForm article={article} />
        {!!products.length && (
          <div className="tw-mt-10 tw-hidden lg:tw-block">
            <RelatedProduct products={products} t={t} />
          </div>
        )}
      </div>
    </>
  );
};
export const PromotionsArticleLayout = (props: IArticle) => {
  const webUrl = process.env.APP_URL;
  const { t } = useTranslation(['layout']);
  const { products, article, newArticles, blogs } = props;
  const { yoast_head_json, title, categories, thumbnail_url, content } =
    article;
  return (
    <>
      <MetaTag title={title.rendered} image={thumbnail_url} />
      <h2 className="tw-hidden">{yoast_head_json.title}</h2>
      <h2 className="tw-hidden">{yoast_head_json.title}</h2>
      <div className="container tw-py-10 md:tw-border-t tw-border-primary-main tw-text-secondary-70">
        <Breadcrumb title={title.rendered} blogId={categories[0]} />
        <article className="tw-mt-10">
          <div className="tw-w-full tw-relative tw-h-[460px] md:tw-h-[370px] lg:tw-h-[400px] xl:tw-h-[420px]">
            <div className="tw-w-full tw-relative tw-pb-[75%] md:tw-pb-[35%] lg:tw-pb-[26%]">
              <Image
                src={thumbnail_url || ''}
                alt={title.rendered}
                className="!tw-absolute tw-w-full tw-h-full tw-left-0 tw-top-0"
                objectFit="cover"
              />
              <div className="tw-w-11/12 md:tw-w-[600px] tw-rounded-t-[28px] tw-px-4 md:tw-px-8 lg:tw-px-10 tw-py-4 lg:tw-py-8 tw-bg-white tw-absolute tw-left-1/2 tw--translate-x-1/2 tw-top-[80%] md:tw-top-[65%] tw-text-center">
                <div className="tw-text-center">
                  {humanTimeArticle(article.modified, '')}
                </div>
                <h1
                  className="tw-mt-3 tw-text-lg md:tw-text-xl lg:tw-text-2xl tw-leading-8 tw-font-semibold tw-text-center"
                  dangerouslySetInnerHTML={{ __html: title.rendered }}
                ></h1>
                <div className="tw-text-center tw-flex tw-items-center tw-justify-center tw-mt-2">
                  Chia sẻ:&nbsp;
                  <FacebookShareButton
                    className=""
                    url={`${webUrl}/article/${article.slug}`}
                  >
                    <Image
                      src="/facebook-color.png"
                      className="tw-w-8 tw-h-8"
                      alt="facebook"
                    />
                  </FacebookShareButton>
                </div>
              </div>
            </div>
          </div>
          <div
            className="tw-text-base md:tw-text-lg tw-mt-6 md:tw-mt-8 tw-text-gray-52 tw-mx-auto lg:tw-w-9/12 xl:tw-w-8/12 tw-prose tw-prose-sm md:tw-prose-base lg:tw-prose-lg content-article"
            dangerouslySetInnerHTML={{ __html: content.rendered }}
          ></div>
        </article>
        <AmbassadorRegistrationForm article={article} />
        {!!products.length && (
          <div className="tw-mt-10 tw-hidden lg:tw-block">
            <RelatedProduct products={products} t={t} />
          </div>
        )}
      </div>
      {!!newArticles.length && (
        <div
          className="tw-w-full tw-py-8 lg:tw-py-12 tw-bg-center tw-bg-cover tw-bg-no-repeat tw-mt-10"
          style={{ backgroundImage: 'url(/bg-live.svg)' }}
        >
          <div className="container tw-mx-auto">
            <div className="tw-w-full">
              <div className="tw-flex tw-items-center tw-w-full tw-relative after:tw-absolute after:tw-right-0 after:tw-top-1/2 after:tw-h-[1px]  after:tw-bg-primary-main/[0.5] before:tw-left-0 before:tw-top-1/2 before:tw-h-[1px] before:tw-bg-primary-main/[0.5] xl:after:tw-w-[300px] xl:before:tw-w-[300px] lg:before:tw-w-[240px] lg:after:tw-w-[240px] md:before:tw-w-[140px] md:after:tw-w-[140px] [425px]:before:tw-w-[30px] before:tw-w-[10px] after:tw-w-[10px] [425px]:after:tw-w-[30px] 2xl:after:tw-w-[400px] 2xl:before:tw-w-[400px]">
                <div className="tw-flex tw-items-center tw-gap-x-4 tw-px-5 tw-absolute tw-left-1/2 tw--translate-x-1/2">
                  <Image
                    src="/diamond.svg"
                    alt="star"
                    className="tw-h-5 tw-w-5"
                  />
                  <span className="tw-inline-block tw-text-lg md:tw-text-2xl tw-uppercase tw-font-semibold tw-w-max tw-text-primary-main">
                    Xem thêm tin tức mới nhất
                  </span>
                  <Image
                    src="/diamond.svg"
                    alt="star"
                    className="tw-h-5 tw-w-5"
                  />
                </div>
              </div>
              <div className="tw-mt-12 tw-grid tw-grid-cols-1 lg:tw-grid-cols-3 tw-gap-4 lg:tw-gap-5">
                {newArticles
                  .filter((n) => n.id != article.id)
                  .slice(0, 3)
                  .map((a) => {
                    const blog = blogs.find((b) => b.id === a.categories[0]);
                    return (
                      <Link
                        url={{
                          pathname: PagePath.ArticlePage,
                          query: { id: a.slug },
                        }}
                        className="tw-w-full tw-rounded-lg tw-overflow-hidden tw-border tw-border-gray-70 hover:tw-border-primary-main !tw-text-secondary-70 tw-duration-500 tw-ease-linear"
                        key={a.title.rendered}
                      >
                        <div className="tw-relative tw-w-full tw-pb-[75%]">
                          <Image
                            src={a.thumbnail_url || ''}
                            alt={a.title.rendered}
                            className="!tw-absolute tw-w-full tw-h-full tw-left-0 tw-right-0"
                            objectFit="cover"
                          />
                        </div>
                        <div className="tw-px-4 tw-py-3 tw-bg-white">
                          <span className="tw-text-13 tw-uppercase tw-leading-[26px]">
                            {blog?.name}
                          </span>
                          <h3
                            className="tw-text-base tw-font-semibold tw-line-clamp-2 tw-leading-[26px]"
                            dangerouslySetInnerHTML={{
                              __html: a.title.rendered,
                            }}
                          ></h3>
                          <span className="tw-leading-6 tw-italic tw-text-sm">
                            {humanTimeArticle(a.modified, '')}
                          </span>
                        </div>
                      </Link>
                    );
                  })}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export const PromotionsArticleMobileLayout = (props: IArticle) => {
  const webUrl = process.env.APP_URL;
  const { t } = useTranslation(['layout']);
  const { products, article, newArticles, blogs } = props;
  const { yoast_head_json, title, categories, thumbnail_url, content } =
    article;
  return (
    <>
      <MetaTag title={title.rendered} image={thumbnail_url} />
      <h2 className="tw-hidden">{yoast_head_json.title}</h2>
      <h2 className="tw-hidden">{yoast_head_json.title}</h2>
      <div className="container tw-py-10 md:tw-border-t tw-border-primary-main tw-text-secondary-70">
        <BreadcrumbMobile title={title.rendered} blogId={categories[0]} />
        <article className="tw-mt-10">
          <div className="tw-w-full tw-relative tw-h-[460px] md:tw-h-[370px] lg:tw-h-[400px] xl:tw-h-[420px]">
            <div className="tw-w-full tw-relative tw-pb-[75%] md:tw-pb-[35%] lg:tw-pb-[26%]">
              <Image
                src={thumbnail_url}
                alt={title.rendered}
                className="!tw-absolute tw-w-full tw-h-full tw-left-0 tw-top-0"
                objectFit="cover"
              />
              <div className="tw-w-11/12 md:tw-w-[600px] tw-rounded-t-[28px] tw-px-4 md:tw-px-8 lg:tw-px-10 tw-py-4 lg:tw-py-8 tw-bg-white tw-absolute tw-left-1/2 tw--translate-x-1/2 tw-top-[80%] md:tw-top-[65%] tw-text-center">
                <div className="tw-text-center">
                  {humanTimeArticle(article.modified, '')}
                </div>
                <h1
                  className="tw-mt-3 tw-text-lg md:tw-text-xl lg:tw-text-2xl tw-leading-8 tw-font-semibold tw-text-center"
                  dangerouslySetInnerHTML={{ __html: title.rendered }}
                ></h1>
                <div className="tw-text-center tw-flex tw-items-center tw-justify-center tw-mt-2">
                  Chia sẻ:&nbsp;
                  <FacebookShareButton
                    className=""
                    url={`${webUrl}/article/${article.slug}`}
                  >
                    <Image
                      src="/facebook-color.png"
                      className="tw-w-8 tw-h-8"
                      alt="facebook"
                    />
                  </FacebookShareButton>
                </div>
              </div>
            </div>
          </div>
          <div
            className="tw-text-base md:tw-text-lg tw-mt-6 md:tw-mt-8 tw-text-gray-52 tw-mx-auto lg:tw-w-9/12 xl:tw-w-8/12 tw-prose tw-prose-sm md:tw-prose-base lg:tw-prose-lg content-article"
            dangerouslySetInnerHTML={{ __html: content.rendered }}
          ></div>
        </article>
        <AmbassadorRegistrationForm article={article} />
        {!!products.length && (
          <div className="tw-mt-10 tw-hidden lg:tw-block">
            <RelatedProduct products={products} t={t} />
          </div>
        )}
      </div>
      {!!newArticles.length && (
        <div
          className="tw-w-full tw-py-8 lg:tw-py-12 tw-bg-center tw-bg-cover tw-bg-no-repeat tw-mt-10"
          style={{ backgroundImage: 'url(/bg-live.svg)' }}
        >
          <div className="container tw-mx-auto">
            <div className="tw-w-full">
              <div className="tw-flex tw-items-center tw-w-full tw-relative after:tw-absolute after:tw-right-0 after:tw-top-1/2 after:tw-h-[1px]  after:tw-bg-primary-main/[0.5] before:tw-left-0 before:tw-top-1/2 before:tw-h-[1px] before:tw-bg-primary-main/[0.5] xl:after:tw-w-[300px] xl:before:tw-w-[300px] lg:before:tw-w-[240px] lg:after:tw-w-[240px] md:before:tw-w-[140px] md:after:tw-w-[140px] [425px]:before:tw-w-[30px] before:tw-w-[10px] after:tw-w-[10px] [425px]:after:tw-w-[30px] 2xl:after:tw-w-[400px] 2xl:before:tw-w-[400px]">
                <div className="tw-flex tw-items-center tw-gap-x-4 tw-px-5 tw-absolute tw-left-1/2 tw--translate-x-1/2">
                  <Image
                    src="/diamond.svg"
                    alt="star"
                    className="tw-h-5 tw-w-5"
                  />
                  <span className="tw-inline-block tw-text-lg md:tw-text-2xl tw-uppercase tw-font-semibold tw-w-max tw-text-primary-main">
                    Xem thêm tin tức mới nhất
                  </span>
                  <Image
                    src="/diamond.svg"
                    alt="star"
                    className="tw-h-5 tw-w-5"
                  />
                </div>
              </div>
              <div className="tw-mt-12 tw-grid tw-grid-cols-1 lg:tw-grid-cols-3 tw-gap-4 lg:tw-gap-5">
                {newArticles
                  .filter((n) => n.id != article.id)
                  .slice(0, 3)
                  .map((a) => {
                    const blog = blogs.find((b) => b.id === a.categories[0]);
                    return (
                      <Link
                        url={{
                          pathname: PagePath.ArticleMobilePage,
                          query: { id: a.slug },
                        }}
                        className="tw-w-full tw-rounded-lg tw-overflow-hidden tw-border tw-border-gray-70 hover:tw-border-primary-main !tw-text-secondary-70 tw-duration-500 tw-ease-linear"
                        key={a.title.rendered}
                      >
                        <div className="tw-relative tw-w-full tw-pb-[75%]">
                          <Image
                            src={a.thumbnail_url}
                            alt={a.title.rendered}
                            className="!tw-absolute tw-w-full tw-h-full tw-left-0 tw-right-0"
                            objectFit="cover"
                          />
                        </div>
                        <div className="tw-px-4 tw-py-3 tw-bg-white">
                          <span className="tw-text-13 tw-uppercase tw-leading-[26px]">
                            {blog?.name}
                          </span>
                          <h3
                            className="tw-text-base tw-font-semibold tw-line-clamp-2 tw-leading-[26px]"
                            dangerouslySetInnerHTML={{
                              __html: a.title.rendered,
                            }}
                          ></h3>
                          <span className="tw-leading-6 tw-italic tw-text-sm">
                            {humanTimeArticle(a.modified, '')}
                          </span>
                        </div>
                      </Link>
                    );
                  })}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
